<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>{{sidebarHeader}}</h4>
      <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>
    
    <VuePerfectScrollbar class="scroll-area--data-list-add-new pt-4 pb-6" :settings="settings">
      <div class="pl-6 pr-6 pb-6">
        <div>
          <label>Scene</label>
          <vs-select placeholder="Search / Select Scene" class="w-full" ref="sceneSelect" vs-multiple autocomplete v-model="formData.sceneId">
            <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in scenes" />
          </vs-select>
        </div>

        <div class="pt-4 pb-6" >
          <label>Name</label>
          <vs-input autocomplete="off" class="w-full" v-model="formData.name"/>
        </div>

        <div class="pt-6">
          <vs-button class="w-full cursor-pointer" color="warning" type="border" icon-pack="feather" icon="icon-settings" :disabled="!finishedLoading" @click="showHideCard" v-show="formData.id" >Manage Mapped Locations</vs-button>
        </div>
      </div>
    </VuePerfectScrollbar>

    <div class="flex flex-wrap items-center justify-center pb-4 pt-1" slot="footer">
      <vs-button ref="addupdateButton" class="mr-4 vs-con-loading__container" :disabled="isDisabled" color="success" @click="addEditNavigationMap">{{ buttoncaption }}</vs-button>
      <vs-button color="danger" class="mr-4 vs-con-loading__container cursor-pointer" v-show="formData.id" @click="openConfirm()" ref="deleteButton">Delete</vs-button>
      <vs-button type="border" class="ml-4 cursor-pointer" color="warning" @click="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    selectedNavigationMap: {
      type: Object,
      required: false
    },
    buttoncaption: {
      type: String,
      required: false
    },
    sidebarHeader: {
      type: String,
      required: false
    }
  },

  data() {
    return {
      backgroundLoading:'#fff',
      formData: {
        id: 0,
        sceneId: "",
        name: ""
      },
      scenes: [],
      sceneImageUrl: "",
      finishedLoading: false,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      }
    };
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
          this.initValues();
        }
      }
    },
    uploadLocation: {
      get() {
          return this.$buildUrl("tempupload");
      }
    },
    isDisabled: function(){
      return !this.formData.name;
    }
  },
  watch: {
    isSidebarActive: function(val) {
      if(val){
        var self = this;
        var onSceneSuccess = sceneResponse => {
          self.scenes = sceneResponse.data;
          self.finishedLoading = true;
        };
        self.$ajaxGet(self, "scene/GetNavigationMapSelectList", onSceneSuccess);
        if(this.selectedNavigationMap.id) {
          this.formData.id = this.selectedNavigationMap.id;
          this.formData.sceneId = this.selectedNavigationMap.sceneId;
          this.formData.name = this.selectedNavigationMap.name;
        }else {
          this.initValues();
        } 
      }
    }
  },
  methods: {
    initValues() {
      this.formData.id = 0;
      this.formData.sceneId = "";
      this.formData.name = "";
      this.errors.clear();
    },
    saveData(){
      this.$emit('saveData');
      this.$vs.loading.close(this.$refs.addupdateButton.$el);
    },
    addEditNavigationMap() {
      var self = this;
        self.showLoadingOnButton();
        var onSuccess = response => {
          self.saveData();
          self.formData.id = response.data;
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.addupdateButton.$el);
        };

        self.$ajaxPost(self, "NavigationMap/AddEditNavigationMap", self.formData, onSuccess, onFinally);
    },
    deleteNavigationMaps() {
      var self = this;
      self.showLoadingOnDeleteButton();

      var onSuccess = response => {
        self.saveData();
        self.initValues();
        self.$vs.notify({
          title:'Information',
          color: "success",
          text: "Navigation Deleted",
          position:'top-right',
          iconPack: 'feather',
          icon:'icon-trash'
        });
      };
      var onFinally = function () {
        self.$vs.loading.close(self.$refs.deleteButton.$el);
      };

      self.$ajaxDelete(self, "NavigationMap/DeleteNavigationMap/" + self.formData.id, onSuccess, onFinally);
    },
    showHideCard(){
      var self = this;
      self.sceneImageUrl = self.scenes.filter(function (item) { return parseInt(item.value) == parseInt(self.formData.sceneId); })[0].imageUrl;
      self.$emit('showHideCard');
    },
    showLoadingOnButton(){
      var self = this;
      self.$vs.loading({
        background: self.backgroundLoading,
        type: "material",
        container: self.$refs.addupdateButton.$el,
        scale: 0.45
      });
    },
    showLoadingOnDeleteButton(){
      var self = this;
      self.$vs.loading({
        background: self.backgroundLoading,
        type: "material",
        container: self.$refs.deleteButton.$el,
        scale: 0.45
      });
    },
    openConfirm() {
      this.$emit("closeSidebar");
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Attention`,
        text: 'Are you sure you want to delete the selected navigation map and ALL of its mapped locations?',
        accept: this.deleteNavigationMaps
      })
    },
  },
  components: {
    VuePerfectScrollbar
  }
};
</script>




<style lang="scss" scoped>
  .add-new-data-sidebar {
    /deep/ .vs-sidebar--background

  {
    z-index: 52010;
  }

  /deep/ .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;
    .img-upload

  {
    margin-top: 2rem;
    .con-img-upload

  {
    padding: 0;
  }

  .con-input-upload {
    width: 100%;
    margin: 0;
  }

  }
  }
  }

  .scroll-area--data-list-add-new {
    height: calc(100% - 4.3rem);
  }
</style>
